import { Checkbox, CheckboxProps } from '@mui/material';
import {
    CheckboxRoundActiveIcon,
    CheckboxRoundIcon,
    CheckboxRoundIndeterminateIcon,
    CheckboxRoundSelectAllActiveIcon,
    CheckboxRoundSelectAllIcon,
} from '@synergy/theme-next';
import { ReactElement } from 'react';

export type PoolCheckBoxVariant = 'default' | 'round' | 'selectAllRound';

export interface PoolCheckboxProps extends CheckboxProps {
    variant?: PoolCheckBoxVariant;
}

const icons: Record<
    PoolCheckBoxVariant,
    { icon?: ReactElement; checkedIcon?: ReactElement; indeterminateIcon?: ReactElement }
> = {
    default: {},
    round: {
        icon: <CheckboxRoundIcon />,
        checkedIcon: <CheckboxRoundActiveIcon />,
        indeterminateIcon: <CheckboxRoundIndeterminateIcon />,
    },
    selectAllRound: {
        icon: <CheckboxRoundSelectAllIcon />,
        checkedIcon: <CheckboxRoundSelectAllActiveIcon />,
        indeterminateIcon: <CheckboxRoundIndeterminateIcon />,
    },
};

/**
 * PoolCheckbox<br>
 * <a href="https://www.figma.com/file/kjfAT06qgLdW52cF1SqWuy/Pool-Alpin-Shop-2.0-Library?node-id=662%3A15734" target="_blank">Open in Figma</a>
 */
export const PoolCheckbox = (props: PoolCheckboxProps): ReactElement => {
    const { variant = 'default', ...checkboxProps } = props;

    const { icon, checkedIcon, indeterminateIcon } = icons[variant];

    return <Checkbox icon={icon} checkedIcon={checkedIcon} indeterminateIcon={indeterminateIcon} {...checkboxProps} />;
};
